export default "/images/vendor/flag-icon-css/flags/4x3/st.svg?a66e38d3051c95e23a7dcb814565d34f";